:host{--h3-subpoint-display: initial}
/*# sourceMappingURL=point.component.css.map */
